import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import axios from '../../../../data/http/axios'
import helpers from '../../../../Classes/helpers'
import { alterSiteDrawer } from '../../../../data/actions/siteActions'

const options = [
    { label: 'When the email is sent', value: '15' },
    { label: 'When the contact opens the email', value: '8' },
    { label: 'When the contact clicks on a link', value: '9' },
    { label: 'If the contact unsubscribes', value: '13' },
    { label: 'If the email bounces', value: '12' }
]

export default function CampaignAutomate({ CampaignId, campaignName, save = () => {} }) {
    const site = useSelector((state) => state.siteMaster)
    const history = useHistory()
    const dispatch = useDispatch()
    const [trigger, setTrigger] = useState('')
    const [name, setName] = useState(campaignName + ' Automation')

    const create = async () => {
        await save()
        const res = await axios.post('/automation', {
            name,
            version: 1,
            status: 'Draft',
            steps: [
                {
                    guid: helpers.createLocalGuid(),
                    type: 'initial',
                    complete: true,
                    parentGuid: 0,
                    stepOptions: {
                        groupId: { value: '-1', required: true },
                        campaignId: { value: CampaignId, required: true }
                    },
                    triggerType: { value: trigger, required: true },
                    wizardComplete: true
                }
            ],
            options: {
                source: 'Campaign Wizard'
            }
        })
        history.push(
            '/cp/automation/addnew/' +
                res.data.Automation.id +
                '?redirect=/cp/campaigns/add/standard/' +
                CampaignId +
                '/3'
        )
        dispatch(alterSiteDrawer(false, true, 'right', null))
    }

    return (
        <div>
            <div className='quickFlex mar-b10' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4>Create an new Automation</h4>
                {site.siteId === 1 && (
                    <Hint
                        href='https://transpond.io/support/automating-your-communications/transpond-automations'
                        iconLeft={
                            <Icons icon='questionCircle' color='#2B2F41' style={{ height: 16, width: 16 }} />
                        }
                    >
                        Learn More
                    </Hint>
                )}
            </div>

            <p className='mar-b25 text-sml'>
                You can start a new automation based on activity on this Campaign. <br />
                <br />
                Then perform lots of actions such as adding a tag to a contact when they open the email to show they are
                engaged or send a follow-up email a few days later if they click on a specific link.
            </p>

            <Select
                outerClassName='mar-b25'
                label='What would you like to trigger an automation?'
                data={options}
                value={trigger}
                onChange={(e) => setTrigger(e.target.value)}
            />

            {!!trigger && (
                <TextInput
                    label='Give this new Automation a name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    outerClassName='mar-b25'
                />
            )}

            {!!trigger && !!name && (
                <>
                    <WarningHolder className='mar-b25'>
                        This will create the automation and take you to the automation designer so you can setup any
                        actions you want to happen when this automation is triggered
                    </WarningHolder>
                    <Button className='button-primary' onClick={create}>
                        Create Automation
                    </Button>
                </>
            )}
        </div>
    )
}
